import React, { useEffect, useState, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";
import { MentionsInput, Mention } from "react-mentions";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Member from "shared/media/user/userIcon.png";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Urls } from "shared/constants/url";
import {
  Send,
  SendIcon,
  MessageQuestion,
  Bookmark,
  Like,
  DownArrow,
  Eye,
  FilePpt,
  Filedoc,
  Filepdf,
  Filexls,
  Download,
} from "shared/components/Icons";
import {
  RenderIf,
  Button,
  ClickMore,
  ImageGrid,
  File,
} from "shared/components";
import { CommunityDiscussionComments } from "shared/components/CommunityDiscussionCard/components";
import {
  imgTypes,
  mainDocType,
  videoTypes,
  docType,
} from "shared/constants/url";
import {
  getVimeoVideoId,
  getYouTubeVideoId,
  processTextWithLinks,
} from "shared/helper/getYoutubeVideoId";
import { handleDownload } from "shared/helper/updateObject";
import { useLazyGetFileQuery } from "redux/api/news";
import {
  useGetAllUsersQuery,
  useDetailedInfoByIdQuery,
} from "redux/api/siteUsers";
import {
  useCreateCommunityDiscussionCommentMutation,
  useDeleteCommunityDiscussionMutation,
  useReportCommunityDiscussionMutation,
  useSendCommunityMutation,
  useLazyGetCommunityDiscussionCommentsQuery,
  useCommunityDiscussionLikeMutation,
  useDeleteCommunityDiscussionLikeMutation,
  useLazyGetCommunityDiscussionDetailQuery,
  useCreateCommunityPostViewMutation,
} from "redux/api/community";
import {
  useBookmarkMutation,
  useDeleteBookmarkMutation,
} from "redux/api/bookmark";
import { EditCommunityDiscussionCard } from "pages/Community/Inner/modals";
import { custom, customStyleSecond } from "shared/helper/mentionStyle";
import { SendModal } from "./modals";
import classNames from "./Card.scss";

const CommunityDiscussionCard = ({
  files,
  discussionComments,
  userImg,
  advice,
  name,
  surname,
  className,
  discussionInterests,
  communityData,
  refetch,
  mission,
  description,
  postID,
  siteUserID,
  cardClickHandler,
  isLiked,
  likeCount,
  viewCount,
  isBookmarked,
  communityDiscussionId,
}) => {
  const { t } = useTranslation();
  const { id: ownerID } = useSelector((state) => state.user.user);
  const { REACT_APP_BASE_PHOTO_URL, REACT_APP_BASE_PHOTO_URL_MAIN } =
    process.env;
  const initialValues = {
    newsId: "",
    description: "",
    siteUserId: "",
    files: [],
  };
  const [createPostView] = useCreateCommunityPostViewMutation();
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [fileData, setFileData] = useState(null);
  const [interests, setInterests] = useState();
  const [discussionFile, setDiscussionFile] = useState();
  const [editInputVal, setEditInputVal] = useState();
  const [toggle, setToggle] = useState(false);
  const [inputVal, setInputVal] = useState("");
  const [selectedId, setSelectedId] = useState([]);
  const handleTagClick = (id) => {
    setSelectedId((prevIds) => [...prevIds, id]);
  };
  const [suggestion, setSuggettion] = useState([]);
  const [getFile] = useLazyGetFileQuery();
  const iframeRef = useRef(null);

  const applyStyles = () => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentDocument) {
      const css = `
        body {
          justify-content: start !important;
          display: flex;
        }
      `;
      const styleElement = iframe.contentDocument.createElement("style");
      styleElement.type = "text/css";
      styleElement.textContent = css;
      iframe.contentDocument.head.appendChild(styleElement);
    }
  };
  const [getCommentsByPost, { data: commentData }] =
    useLazyGetCommunityDiscussionCommentsQuery();
  const [likeCommunityPost, { isSuccess: likeSuccess }] =
    useCommunityDiscussionLikeMutation();
  const [deleteCommunityLike, { isSuccess: deleteLikeSuccess }] =
    useDeleteCommunityDiscussionLikeMutation();
  const [bookmark, { isSuccess: bookmarkSuccess }] = useBookmarkMutation();
  const [deleteBookmark, { isSuccess: deleteBookmarkSuccess }] =
    useDeleteBookmarkMutation();
  const [
    getCommunityDiscussionDetail,
    { data: discussionData, isSuccess: discussionDataSuccess },
  ] = useLazyGetCommunityDiscussionDetailQuery();
  const likePost = () => {
    const formData = new FormData();
    formData.append("CommunityDiscussionId", postID);
    likeCommunityPost(formData);
    createPostView({ communityDiscussionId: postID });
  };
  const deleteLike = () => {
    const data = {
      communityDiscussionId: postID,
    };
    deleteCommunityLike(data);
    createPostView({ communityDiscussionId: postID });
  };
  const saveBookmark = () => {
    const formData = new FormData();

    formData.append("CommunityDiscussionId", postID);

    bookmark(formData);
    createPostView({ communityDiscussionId: postID });
  };
  const deleteBookmarked = () => {
    const data = {
      communityDiscussionId: postID,
    };
    deleteBookmark(data);
    createPostView({ communityDiscussionId: postID });
  };
  let formattedMessage = inputVal;
  selectedId?.forEach((id, index) => {
    const regex = new RegExp(`@\\[.*?\\]\\(${id}\\)`, "g");
    formattedMessage = formattedMessage.replace(regex, `@${id}`);
  });

  const [showMore, setShowMore] = useState(true);
  const [show, setShow] = useState(false);
  const [modal, setModal] = useState(false);
  const [partsOther, setPartsOther] = useState([]);
  const { id } = useSelector((state) => state.user.user);
  const { data } = useDetailedInfoByIdQuery({ id });
  const getImagesFromFile = (value) => {
    setFileData(value);
  };

  const [deleteCommunity, { isSuccess: deleteSuccess }] =
    useDeleteCommunityDiscussionMutation();
  const { data: usersEmail, isSuccess: usersSuccess } = useGetAllUsersQuery({});

  const [createComment, { isSuccess: commentSuccess }] =
    useCreateCommunityDiscussionCommentMutation();
  const [
    reportDiscussion,
    {
      isSuccess: reportSuccess,
      isError: reportError,
      isLoading: reportLoading,
    },
  ] = useReportCommunityDiscussionMutation();

  const deletePost = () => deleteCommunity(postID);

  const titles = [
    {
      id: uuid(),
      title: t("edit"),
      onClick: () => {
        setShow(true);
        createPostView({ communityDiscussionId: postID });

        getCommunityDiscussionDetail(postID);
        setDiscussionFile(discussionData?.communityDiscussionFiles);
        setEditInputVal(discussionData?.text);
        setInterests(discussionData?.communityDiscussionInterests);
      },
    },
    {
      id: uuid(),
      title: t("delete"),
      onClick: deletePost,
    },
  ];

  const formik = useFormik({
    initialValues,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      if (values.submitType === "POST2") {
        const comment = new FormData();
        comment.append("communityDiscussionId", communityData);
        formattedMessage && comment.append("description", formattedMessage);
        comment.append("siteUserId", id);
        if (fileData?.length) {
          for (let i = 0; i < fileData?.length; i++) {
            comment.append(`files`, fileData?.[i]);
          }
        } else {
          comment.append(`files`, null);
        }

        let condition = !inputVal?.trim() && !fileData?.length;
        !condition && createComment(comment);
      }

      resetForm();
    },
  });
  const reportCommunityDiscussion = () => {
    const formData = new FormData();
    formData.append("SiteUserId", id);
    formData.append("DiscussionId", postID);
    reportDiscussion(formData);
    createPostView({ communityDiscussionId: postID });
  };

  function handleLoadMore() {
    setRowsPerPage(rowsPerPage + 3);
    getCommentsByPost({
      communityDiscussionId: postID,
      skip: 0,
      take: rowsPerPage + 3,
      orderBy: false,
      sortField: "id",
    });
  }
  const imageClickHandler = (e) => {
    e.stopPropagation();
  };
  useEffect(() => {
    if (deleteSuccess) {
      refetch();
    }
  }, [deleteSuccess]);

  useEffect(() => {
    if (commentSuccess) {
      setFileData(null);
      setModal(false);
      setInputVal("");
      refetch();
      toast.success("Send successfully !", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }, [commentSuccess]);
  useEffect(() => {
    if (reportSuccess) {
      toast.success("Send successfully !", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } else if (reportError) {
      toast.error("Please try again !", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }, [reportLoading]);

  useEffect(() => {
    const formattedData = usersEmail?.data?.map((user) => ({
      id: user.id,
      display: `${user.firstName} ${user.lastName}`,
    }));
    setSuggettion(formattedData);
  }, [usersSuccess]);

  useEffect(() => {
    const extractLinks = (text) => {
      if (!text) {
        return [];
      }

      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const matches = text.match(urlRegex);

      if (!matches) {
        return [];
      }

      const parts = text.split(urlRegex);

      const links = parts.reduce((acc, part, index) => {
        if (matches.includes(part)) {
          acc.push(part);
        }
        return acc;
      }, []);

      return links;
    };

    const extractedLinks = extractLinks(description);
    setPartsOther(extractedLinks);
  }, [description]);
  useEffect(() => {
    if (
      deleteBookmarkSuccess ||
      bookmarkSuccess ||
      deleteLikeSuccess ||
      likeSuccess
    ) {
      refetch();
    }
  }, [deleteBookmarkSuccess, bookmarkSuccess, deleteLikeSuccess, likeSuccess]);
  useEffect(() => {
    if (discussionDataSuccess) {
      setDiscussionFile(discussionData?.communityDiscussionFiles);
      setEditInputVal(discussionData?.text);
      setInterests(discussionData?.communityDiscussionInterests);
    }
  }, [discussionData, postID, discussionDataSuccess]);
  return (
    <div className={`cardMain ${className}`}>
      <div
        onClick={cardClickHandler}
        className="cardMainTop d-flex justify-content-between">
        <div className="d-flex">
          <div className="cardMainTopLeft">
            <Link
              to={Urls.POSTS_URL + `/${siteUserID}`}
              onClick={imageClickHandler}>
              <img
                alt="user"
                src={userImg ? `${REACT_APP_BASE_PHOTO_URL}${userImg}` : Member}
              />
            </Link>
          </div>
          <div className="cardMainTopRight">
            <Link
              to={Urls.POSTS_URL + `/${siteUserID}`}
              onClick={imageClickHandler}>
              <h4 className="name">
                {name} {surname}
              </h4>{" "}
            </Link>
            <p className="duty">{mission}</p>
          </div>
        </div>
      </div>
      <div className="cardMainCenter">
        <RenderIf condition={description}>
          <div className="cardMainCenterText emojiField">
            <p>
              <RenderIf
                condition={files?.length}
                renderElse={
                  <>
                    <div style={{ whiteSpace: "pre-line" }}>
                      {processTextWithLinks(description)}
                      {partsOther?.map((link, index) => {
                        if (
                          link?.startsWith("https://www.youtube") ||
                          link?.startsWith("https://youtube") ||
                          link?.startsWith("https://youtu.be")
                        ) {
                          const shortVideoID = link.split("/").slice(-1)[0];
                          const videoId = getYouTubeVideoId(link);
                          const embedUrl =
                            link?.startsWith(
                              "https://www.youtube.com/shorts"
                            ) || link?.startsWith("https://youtube")
                              ? `https://www.youtube.com/embed/${shortVideoID}`
                              : `https://www.youtube.com/embed/${videoId}`;
                          return (
                            <div className="mt-2" key={index}>
                              <iframe
                                width="80%"
                                height="400"
                                src={embedUrl}
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                title="YouTube Video"
                                allowFullScreen></iframe>
                            </div>
                          );
                        } else if (link?.startsWith("https://vimeo.com/")) {
                          const videoId = getVimeoVideoId(link);
                          if (!videoId) {
                            return <div key={index}>Invalid Vimeo link</div>;
                          }
                          const embedUrl = `https://player.vimeo.com/video/${videoId}`;
                          return (
                            <div
                              className="vimeo-container"
                              style={{
                                paddingTop: "10px",
                                position: "relative",
                              }}
                              key={index}>
                              <iframe
                                ref={iframeRef}
                                onLoad={applyStyles}
                                src={`${embedUrl}?badge=0&autopause=0&player_id=0&app_id=58479`}
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                width="80%"
                                height="400"
                                title={`Vimeo Video - ${videoId}`}
                                allowFullScreen></iframe>
                            </div>
                          );
                        } else if (link?.startsWith("https://vimeo.com/")) {
                          const videoId = getVimeoVideoId(link);
                          if (!videoId) {
                            return <div key={index}>Invalid Vimeo link</div>;
                          }
                          const embedUrl = `https://player.vimeo.com/video/${videoId}`;
                          return (
                            <div
                              className="vimeo-container"
                              style={{
                                padding: "10px",
                                position: "relative",
                              }}
                              key={index}>
                              <iframe
                                src={`${embedUrl}?badge=0&autopause=0&player_id=0&app_id=58479`}
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                                width="80%"
                                height="400"
                                title={`Vimeo Video - ${videoId}`}
                                allowFullScreen></iframe>
                            </div>
                          );
                        }
                      })}
                    </div>
                  </>
                }>
                <RenderIf
                  condition={showMore}
                  renderElse={
                    <div
                      onClick={() => setShowMore(!showMore)}
                      style={{ whiteSpace: "pre-line" }}>
                      {" "}
                      {processTextWithLinks(description)}
                    </div>
                  }>
                  <div
                    onClick={() => setShowMore(!showMore)}
                    style={{ whiteSpace: "pre-line" }}>
                    {" "}
                    {processTextWithLinks(description?.substring(0, 250))}
                  </div>
                </RenderIf>
              </RenderIf>
            </p>
            <RenderIf condition={files?.length}>
              <RenderIf condition={description?.length > 250}>
                <button onClick={() => setShowMore(!showMore)} className="more">
                  {showMore ? "See more..." : "See less..."}
                </button>
              </RenderIf>
            </RenderIf>
          </div>
        </RenderIf>
        <RenderIf condition={discussionInterests?.length}>
          <div className="d-flex flex-wrap align-items-center mt-4 mb-2">
            {discussionInterests?.map((c) => (
              <div key={c?.id} className="cardMainCenterTextTag">
                <span>{`#${c?.name}`}</span>
              </div>
            ))}
          </div>
        </RenderIf>
        <RenderIf condition={files?.length}>
          <div className="mt-3">
            <>
              {files?.some((item) => {
                const extension = item.fileUrl.split(".").pop().toLowerCase();
                return docType.includes(extension);
              }) && (
                <div className="d-flex mb-3">
                  {files
                    .filter((item) => {
                      const extension = item.fileUrl
                        .split(".")
                        .pop()
                        .toLowerCase();
                      return docType.includes(extension);
                    })
                    .map((item, index) => {
                      const extension = item.fileUrl
                        .split(".")
                        .pop()
                        .toLowerCase();

                      const fileIcons = {
                        doc: <Filedoc width="60px" height="60px" />,
                        docx: <Filedoc width="60px" height="60px" />,
                        pdf: <Filepdf width="60px" height="60px" />,
                        pptx: <FilePpt width="60px" height="60px" />,
                        ppt: <FilePpt width="60px" height="60px" />,
                        xlsx: <Filexls width="60px" height="60px" />,
                        xls: <Filexls width="60px" height="60px" />,
                      };
                      const FileComponent = fileIcons[extension] || null;
                      return (
                        <div key={index} className="svg-wrapper mt-2">
                          {FileComponent}
                          <div
                            onClick={() => {
                              handleDownload(item?.id, item?.fileUrl, getFile);
                            }}
                            className="svg-wrapper-svg">
                            <Download />
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
              {files?.some((item) => {
                const extension = item.fileUrl.split(".").pop().toLowerCase();
                return (
                  imgTypes.includes(extension) || videoTypes.includes(extension)
                );
              }) && (
                <div
                  style={{
                    width: "100%",
                    marginBottom: "20px",
                  }}>
                  <ImageGrid>
                    {files
                      .filter((item) => {
                        const extension = item.fileUrl
                          .split(".")
                          .pop()
                          .toLowerCase();
                        return (
                          imgTypes.includes(extension) ||
                          videoTypes.includes(extension)
                        );
                      })
                      .map((item) => {
                        const extension = item.fileUrl
                          .split(".")
                          .pop()
                          .toLowerCase();
                        if (imgTypes.includes(extension)) {
                          return (
                            <img
                              key={item?.id}
                              src={`${REACT_APP_BASE_PHOTO_URL_MAIN}${item.fileUrl}`}
                              alt="img"
                            />
                          );
                        } else if (videoTypes.includes(extension)) {
                          return (
                            <video key={item?.id} controls>
                              <source
                                src={`${REACT_APP_BASE_PHOTO_URL_MAIN}${item.fileUrl}`}
                              />
                            </video>
                          );
                        }
                      })}
                  </ImageGrid>
                </div>
              )}
              <div>
                {files
                  ?.filter((item) => {
                    const extension = item.fileUrl
                      .split(".")
                      .pop()
                      .toLowerCase();
                    return (
                      !imgTypes.includes(extension) &&
                      !videoTypes.includes(extension) &&
                      !mainDocType.includes(extension) &&
                      extension !== "pdf"
                    );
                  })
                  .map((item) => (
                    <p key={item?.id}>{item.fileUrl}</p>
                  ))}
              </div>
            </>
          </div>
        </RenderIf>
      </div>
      <div className="cardMainBottom align-items-center justify-content-between">
        <div className="d-flex align-items-center cardBottom ">
          <div className="cardMainBottomIcon d-flex align-items-center">
            <Tooltip title={t("like")}>
              <div
                onClick={isLiked ? deleteLike : likePost}
                className={`${
                  isLiked ? "like-active" : ""
                } d-flex align-items-center`}>
                <Like />
                <div className="d-flex align-items-center">
                  <span> {t("like")}</span>
                  <span>({likeCount})</span>
                </div>
              </div>
            </Tooltip>
          </div>
          <Tooltip title={t("share")}>
            <div
              onClick={() => {
                setModal(true);
                createPostView({ communityDiscussionId: postID });
              }}
              className="cardMainBottomIcon">
              <SendIcon />
              <span> {t("share")}</span>
            </div>
          </Tooltip>
          <Tooltip title={t("comment")}>
            <div
              onClick={() => {
                createPostView({
                  communityDiscussionId: postID,
                });

                setToggle(!toggle);
                getCommentsByPost({
                  communityDiscussionId: postID,
                  skip: 0,
                  take: rowsPerPage,
                  orderBy: false,
                  sortField: "id",
                });
              }}
              className="cardMainBottomIcon">
              <Send />
              <span>
                {" "}
                {t("comment")} ({discussionComments?.length})
              </span>
            </div>
          </Tooltip>
          <Tooltip title={t("Bookmark")}>
            <div
              onClick={isBookmarked ? deleteBookmarked : saveBookmark}
              className={`${
                isBookmarked ? "like-active" : ""
              } cardMainBottomIcon`}>
              <Bookmark />
              <span> {t("Bookmark")}</span>
            </div>
          </Tooltip>
          <Tooltip title={t("reportIt")}>
            <div
              onClick={reportCommunityDiscussion}
              className="cardMainBottomIcon">
              <MessageQuestion />
              <span> {t("reportIt")}</span>
            </div>
          </Tooltip>
        </div>
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center newsCardOneRightBottomIcon mx-2">
            <Eye />{" "}
            <span className="mx-2">
              {viewCount} {t("view")}
            </span>
          </div>
          <RenderIf condition={ownerID === siteUserID}>
            <div>
              <ClickMore background="#F3F8F6" buttonTitles={titles} />
              <EditCommunityDiscussionCard
                refetch={refetch}
                interests={interests}
                inputVal={editInputVal}
                setInputVal={setEditInputVal}
                show={show}
                close={() => setShow(false)}
                postID={postID}
                disType={advice}
                siteUserID={siteUserID}
                name={name}
                surname={surname}
                filer={discussionFile}
                setDiscussionFile={setDiscussionFile}
              />
            </div>
          </RenderIf>
        </div>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <RenderIf condition={toggle}>
          <div className="newsCardComment">
            <div className="newsCardCommentInput d-flex">
              <div className="newsCardCommentInputLeft">
                <img
                  alt="user"
                  src={
                    data?.profilePhotoUrl
                      ? `${REACT_APP_BASE_PHOTO_URL}${data?.profilePhotoUrl}`
                      : Member
                  }
                />
              </div>
              <div className="newsCardCommentInputRight">
                <div>
                  <MentionsInput
                    autoFocus={false}
                    value={inputVal}
                    onChange={(e) => {
                      setInputVal(e.target.value);
                    }}
                    placeholder={t("writeComment")}
                    style={customStyleSecond}
                    classNames={classNames}>
                    <Mention
                      key={() => uuid()}
                      trigger="@"
                      data={suggestion}
                      onAdd={handleTagClick}
                      style={custom}
                    />
                  </MentionsInput>
                </div>

                <File
                  commentSuccess={commentSuccess}
                  handleImageFile={getImagesFromFile}
                />
                <button
                  className="sendButton"
                  onClick={() => formik.setFieldValue("submitType", "POST2")}
                  type="submit">
                  <SendIcon />
                </button>
              </div>
            </div>

            {commentData?.map((c) => (
              <CommunityDiscussionComments
                key={c?.discussionId}
                communityDiscussionId={communityDiscussionId}
                isLiked={c?.isLiked}
                likeCount={c?.likeCount}
                siteUserId={c?.siteUserId}
                description={c?.text}
                userName={c?.siteUserName}
                userPhoto={c?.siteUserFileUrl}
                createDate={c?.createdDate}
                newsCommentFiles={c?.communityDiscussionCommentFiles}
                commentId={c?.id}
                refetch={refetch}
              />
            ))}
            <RenderIf condition={commentData?.length}>
              <Button
                onClick={handleLoadMore}
                className="showMoreButton mt-3"
                marginRight="8px"
                icon={<DownArrow />}>
                {t("showMore")}
              </Button>
            </RenderIf>
          </div>
        </RenderIf>
      </form>
      <SendModal id={postID} modal={modal} setModal={setModal} />
    </div>
  );
};

export default CommunityDiscussionCard;
